import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';
import './estilodash.css';

const FORM_INICIAL = {
  id: null,
  codigo: '',
  nome: '',
  descricao: '',
  ativar_cliente: 1,
  trial_dias: '',
  trial_ate: '',
  valido_de: '',
  valido_ate: '',
  limite_uso: '',
  ativo: 1,
};

function formatDate(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString('pt-BR');
}

function toInputDate(value) {
  if (!value) return '';
  return String(value).slice(0, 10);
}

function getTrialLabel(cupom) {
  if (cupom.trial_ate) return `Ate ${formatDate(cupom.trial_ate)}`;
  if (cupom.trial_dias) return `${cupom.trial_dias} dias`;
  return cupom.ativar_cliente ? 'Ativa sem data' : '-';
}

export default function CuponsPromocionais() {
  const [cupons, setCupons] = useState([]);
  const [form, setForm] = useState(FORM_INICIAL);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');

  const carregar = async () => {
    try {
      setLoading(true);
      setErro('');
      const resp = await api.get('/api/cupons-promocionais');
      setCupons(resp.data || []);
    } catch (error) {
      console.error('Erro ao carregar cupons promocionais:', error);
      setErro('Erro ao carregar cupons promocionais.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar().catch(console.error);
  }, []);

  const cuponsFiltrados = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    if (!termo) return cupons;

    return cupons.filter((cupom) => (
      String(cupom.codigo || '').toLowerCase().includes(termo) ||
      String(cupom.nome || '').toLowerCase().includes(termo) ||
      String(cupom.descricao || '').toLowerCase().includes(termo)
    ));
  }, [cupons, busca]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const limparForm = () => {
    setForm(FORM_INICIAL);
    setMsg('');
    setErro('');
  };

  const editar = (cupom) => {
    setForm({
      id: cupom.id,
      codigo: cupom.codigo || '',
      nome: cupom.nome || '',
      descricao: cupom.descricao || '',
      ativar_cliente: Number(cupom.ativar_cliente) === 1 ? 1 : 0,
      trial_dias: cupom.trial_dias || '',
      trial_ate: toInputDate(cupom.trial_ate),
      valido_de: toInputDate(cupom.valido_de),
      valido_ate: toInputDate(cupom.valido_ate),
      limite_uso: cupom.limite_uso || '',
      ativo: Number(cupom.ativo) === 1 ? 1 : 0,
    });
    setMsg('');
    setErro('');
  };

  const salvar = async (event) => {
    event.preventDefault();
    setMsg('');
    setErro('');

    const payload = {
      ...form,
      codigo: String(form.codigo || '').trim().toUpperCase(),
      trial_dias: form.trial_dias === '' ? null : Number(form.trial_dias),
      limite_uso: form.limite_uso === '' ? null : Number(form.limite_uso),
      trial_ate: form.trial_ate || null,
      valido_de: form.valido_de || null,
      valido_ate: form.valido_ate || null,
      ativar_cliente: Number(form.ativar_cliente),
      ativo: Number(form.ativo),
    };

    try {
      if (form.id) {
        await api.put(`/api/cupons-promocionais/${form.id}`, payload);
        setMsg('Cupom atualizado com sucesso.');
      } else {
        await api.post('/api/cupons-promocionais', payload);
        setMsg('Cupom criado com sucesso.');
      }

      setForm(FORM_INICIAL);
      await carregar();
    } catch (error) {
      console.error('Erro ao salvar cupom:', error);
      setErro(error.response?.data?.message || 'Erro ao salvar cupom.');
    }
  };

  const remover = async (cupom) => {
    if (!window.confirm(`Remover o cupom "${cupom.codigo}" da lista ativa?`)) {
      return;
    }

    try {
      await api.delete(`/api/cupons-promocionais/${cupom.id}`);
      setMsg('Cupom removido com sucesso.');
      await carregar();
    } catch (error) {
      console.error('Erro ao remover cupom:', error);
      setErro(error.response?.data?.message || 'Erro ao remover cupom.');
    }
  };

  return (
    <div className="pagamentos-container">
      <h2>Cupons Promocionais</h2>
      <p>
        Gerencie codigos que ativam automaticamente a conta no cadastro e
        definem o periodo de teste do cliente.
      </p>

      {msg && <div className="msg-sucesso">{msg}</div>}
      {erro && <div className="msg-erro">{erro}</div>}

      <form onSubmit={salvar} className="card-like">
        <div className="form-linha">
          <label>
            Codigo
            <input
              value={form.codigo}
              onChange={(e) => handleChange('codigo', e.target.value.toUpperCase())}
              placeholder="EX: TESTE30"
            />
          </label>

          <label>
            Nome
            <input
              value={form.nome}
              onChange={(e) => handleChange('nome', e.target.value)}
              placeholder="Campanha junho"
            />
          </label>

          <label>
            Status
            <select
              value={form.ativo}
              onChange={(e) => handleChange('ativo', Number(e.target.value))}
            >
              <option value={1}>Ativo</option>
              <option value={0}>Inativo</option>
            </select>
          </label>
        </div>

        <div className="form-linha">
          <label>
            Ativar cliente
            <select
              value={form.ativar_cliente}
              onChange={(e) => handleChange('ativar_cliente', Number(e.target.value))}
            >
              <option value={1}>Sim</option>
              <option value={0}>Nao</option>
            </select>
          </label>

          <label>
            Teste em dias
            <input
              type="number"
              min="1"
              value={form.trial_dias}
              onChange={(e) => handleChange('trial_dias', e.target.value)}
              placeholder="Ex: 30"
            />
          </label>

          <label>
            Ou teste ate
            <input
              type="date"
              value={form.trial_ate}
              onChange={(e) => handleChange('trial_ate', e.target.value)}
            />
          </label>
        </div>

        <div className="form-linha">
          <label>
            Cupom valido de
            <input
              type="date"
              value={form.valido_de}
              onChange={(e) => handleChange('valido_de', e.target.value)}
            />
          </label>

          <label>
            Cupom valido ate
            <input
              type="date"
              value={form.valido_ate}
              onChange={(e) => handleChange('valido_ate', e.target.value)}
            />
          </label>

          <label>
            Limite de uso
            <input
              type="number"
              min="1"
              value={form.limite_uso}
              onChange={(e) => handleChange('limite_uso', e.target.value)}
              placeholder="Em branco = sem limite"
            />
          </label>
        </div>

        <label>
          Descricao
          <textarea
            value={form.descricao}
            onChange={(e) => handleChange('descricao', e.target.value)}
            placeholder="Observacao interna sobre a campanha."
          />
        </label>

        <div className="barra-acoes-pagamento">
          <button type="submit" className="qt-btn qt-btn-primary">
            {form.id ? 'Salvar alteracoes' : 'Criar cupom'}
          </button>
          {form.id ? (
            <button type="button" className="qt-btn qt-btn-neutral" onClick={limparForm}>
              Cancelar edicao
            </button>
          ) : null}
        </div>
      </form>

      <div className="qt-filter-panel" style={{ marginTop: 16 }}>
        <label>
          Buscar cupom
          <input
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            placeholder="Codigo, nome ou descricao"
          />
        </label>
      </div>

      {loading ? (
        <p>Carregando cupons...</p>
      ) : (
        <table className="clientes-table">
          <thead>
            <tr>
              <th>Codigo</th>
              <th>Nome</th>
              <th>Teste</th>
              <th>Validade do cupom</th>
              <th>Uso</th>
              <th>Status</th>
              <th>Acoes</th>
            </tr>
          </thead>
          <tbody>
            {cuponsFiltrados.map((cupom) => (
              <tr key={cupom.id}>
                <td><strong>{cupom.codigo}</strong></td>
                <td style={{ textAlign: 'left' }}>
                  {cupom.nome || '-'}
                  {cupom.descricao ? (
                    <>
                      <br />
                      <small>{cupom.descricao}</small>
                    </>
                  ) : null}
                </td>
                <td>{getTrialLabel(cupom)}</td>
                <td>
                  {formatDate(cupom.valido_de)} ate {formatDate(cupom.valido_ate)}
                </td>
                <td>
                  {cupom.usos || 0}
                  {cupom.limite_uso ? ` / ${cupom.limite_uso}` : ' / sem limite'}
                </td>
                <td>
                  {Number(cupom.ativo) === 1 ? (
                    <span className="qt-badge qt-badge-success">Ativo</span>
                  ) : (
                    <span className="qt-badge qt-badge-danger">Inativo</span>
                  )}
                </td>
                <td>
                  <div className="cliente-acoes">
                    <button type="button" className="qt-btn qt-btn-warning" onClick={() => editar(cupom)}>
                      Editar
                    </button>
                    <button type="button" className="qt-btn qt-btn-danger" onClick={() => remover(cupom)}>
                      Remover
                    </button>
                  </div>
                </td>
              </tr>
            ))}

            {cuponsFiltrados.length === 0 ? (
              <tr>
                <td colSpan="7">Nenhum cupom encontrado.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      )}
    </div>
  );
}
